import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { SOCIALS } from "@/components/SocialIcons";

const BUBBLE_EVERY_MS = 45000;
const BUBBLE_VISIBLE_MS = 6000;

export default function SocialSideBar() {
  const { pathname } = useLocation();
  const [bubble, setBubble] = useState(false);
  const [muted, setMuted] = useState(false);

  useEffect(() => {
    if (muted) return;
    let hide;
    const show = () => {
      setBubble(true);
      hide = setTimeout(() => setBubble(false), BUBBLE_VISIBLE_MS);
    };
    const first = setTimeout(show, 8000);
    const every = setInterval(show, BUBBLE_EVERY_MS);
    return () => { clearTimeout(first); clearInterval(every); clearTimeout(hide); };
  }, [muted]);

  if (pathname.startsWith("/admin")) return null;

  return (
    <div data-testid="social-sidebar" className="fixed left-0 top-1/2 -translate-y-1/2 z-[55] flex items-center pointer-events-none">
      <div className="pointer-events-auto flex flex-col gap-1.5 md:gap-2 bg-black/70 backdrop-blur-md border border-white/10 border-l-0 rounded-r-2xl p-1.5 md:p-2 shadow-2xl">
        {SOCIALS.map((s) => (
          <a
            key={s.key}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.label}
            title={s.label}
            data-testid={`sidebar-social-${s.key}`}
            className="w-8 h-8 md:w-10 md:h-10 p-2 md:p-2.5 rounded-xl text-white flex items-center justify-center transition-transform duration-200 hover:translate-x-1 hover:scale-110"
            style={{ background: s.bg }}
          >
            {s.svg}
          </a>
        ))}
      </div>
      <SocialBubble visible={bubble && !muted} onClose={() => { setBubble(false); setMuted(true); }} />
    </div>
  );
}

function SocialBubble({ visible, onClose }) {
  return (
    <div
      data-testid="social-follow-bubble"
      aria-hidden={!visible}
      className={`relative ml-3 max-w-[170px] md:max-w-[220px] bg-[#22ff66] text-black text-xs md:text-sm font-bold leading-snug rounded-2xl rounded-bl-sm px-4 py-3 pr-7 shadow-2xl transition-[opacity,transform] duration-500 ${
        visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-6"
      } pointer-events-none`}
    >
      Seguici sui nostri canali social!
      <button type="button" data-testid="social-bubble-close" onClick={onClose} aria-label="Chiudi" className={`absolute top-1.5 right-1.5 w-5 h-5 flex items-center justify-center rounded-full hover:bg-black/10 ${visible ? "pointer-events-auto" : ""}`}>
        <X className="w-3 h-3" />
      </button>
    </div>
  );
}
